import React from 'react';
import { IoAlertCircleOutline } from 'react-icons/io5';
import styles from './DeleteConfirmModal.module.css';

function DeleteConfirmModal({ isOpen, onClose, onConfirm, productName }) {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                {/* Icon */}
                <div className={styles.iconContainer}>
                    <IoAlertCircleOutline className={styles.icon} />
                </div>

                {/* Title */}
                <h2 className={styles.title}>Delete product?</h2>

                {/* Message */}
                <p className={styles.message}>
                    {productName ? (
                        <>
                            Are you sure you want to delete <strong>"{productName}"</strong>? This action cannot be undone.
                        </>
                    ) : (
                        'Are you sure you want to delete this product? This action cannot be undone.'
                    )}
                </p>

                {/* Actions */}
                <div className={styles.actions}>
                    <button
                        className={styles.cancelButton}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className={styles.deleteButton}
                        onClick={() => {
                            onConfirm();
                            onClose();
                        }}
                    >
                        Delete product
                    </button>
                </div>
            </div>
        </div>
    );
}

export default DeleteConfirmModal;
